






















































import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseCard from '../base-card/_base-card.vue';

@Component({
  name: 'BaseItem',
  components: {
    BaseCard,
  },
})
export default class BaseItem extends Vue {
  @Prop() thumbUrl: string;
  @Prop() clickable?: boolean;
  @Prop() disabled?: boolean;
  @Prop() fallbackThumbUrl?: string;

  imageLoaded = false;
  imageError = false;

  get role(): string {
    return this.clickable ? 'button' : '';
  }

  get imageReady(): boolean {
    if (this.imageError) {
      return false;
    }
    return !!this.thumbUrl && this.imageLoaded;
  }

  handleClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('click');
  }

  handleLoad() {
    this.imageLoaded = true;
    this.imageError = false;
  }

  handleError() {
    this.imageError = true;
  }
}
